import React, {lazy, Suspense} from 'react';
import './App.scss';
import {Route, Switch, BrowserRouter, HashRouter} from 'react-router-dom';
import PreLoader from './components/PreLoader/PreLoader';


const ProtectedRoutes = lazy(() => import('./protectedRoutes'));
const SignIn = lazy(() => import('./pages/SignIn/SignIn'))
const ForgotPassword = lazy(() => import('./pages/SignIn/ForgotPassword'))
const ResetPassword = lazy(() => import('./pages/SignIn/ResetPassword'))

function App() {
  return (
    <React.Fragment>
      <HashRouter>
        <Switch>
          <Suspense fallback={<PreLoader />}>
 
            {/* Sign in */}
            <Route path='/' exact component={SignIn}></Route>
            <Route path='/forgot-password' exact component={ForgotPassword}></Route>
            <Route path='/reset-password/:id' exact component={ResetPassword}></Route>

            {/* Dashboard */}
            <Route path='/dashboard' component={ProtectedRoutes}></Route>

            {/* User Management */}
            <Route path='/create-user' component={ProtectedRoutes}></Route>
            <Route path='/user-list' component={ProtectedRoutes}></Route>
            <Route exact path="/user/:id" component={ProtectedRoutes}></Route>

            {/* Merchant Management */}
            <Route path='/create-merchant' component={ProtectedRoutes}></Route>
            <Route path='/merchant-list' component={ProtectedRoutes}></Route>
            <Route exact path="/merchant/:id" component={ProtectedRoutes}></Route>

            {/* Institution Management */}
            <Route path='/institutions' component={ProtectedRoutes}></Route>
            <Route path='/add-institution' component={ProtectedRoutes}></Route>
            <Route path='/institution/:id' component={ProtectedRoutes}></Route>
            <Route path='/institution-provider/:id' component={ProtectedRoutes}></Route>

            {/* Wallet Management */}
            <Route path='/wallets' component={ProtectedRoutes}></Route>
            <Route path='/disbursement' component={ProtectedRoutes}></Route>
            <Route path='/wallet/:id' component={ProtectedRoutes}></Route>
            <Route path='/walletTransactions/:id' component={ProtectedRoutes}></Route>

            {/* Terminal Management */}
            <Route path='/all-terminals' component={ProtectedRoutes}></Route>
            <Route path='/download-key' component={ProtectedRoutes}></Route>
            <Route path='/add-terminal' component={ProtectedRoutes}></Route>
            <Route path='/terminal/:id' component={ProtectedRoutes}></Route>

            {/* Reporting */}
            <Route path='/transactions' component={ProtectedRoutes}></Route>
            <Route path='/transaction/:id' component={ProtectedRoutes}></Route>
            <Route path='/dailyincome' component={ProtectedRoutes}></Route>
            <Route path='/dailyincomeinstitutions/:id' component={ProtectedRoutes}></Route>

            {/* Audit */}
            <Route path='/audit' component={ProtectedRoutes}></Route>

            {/* Dispute Resolution */}
            <Route path='/disputes' component={ProtectedRoutes}></Route>
            <Route path='/dispute/:id' component={ProtectedRoutes}></Route>

            {/* Settlement report */}
            <Route path='/verify-settlement' component={ProtectedRoutes}></Route>
            <Route path='/settlement-report' component={ProtectedRoutes}></Route>
            <Route path='/potential-dispute' component={ProtectedRoutes}></Route>

            {/* Service Providers */}
            <Route path='/serviceproviders' component={ProtectedRoutes}></Route>
            <Route path='/provider/:id' component={ProtectedRoutes}></Route>
            <Route path='/paymentservicelist' component={ProtectedRoutes}></Route>
            <Route path='/transfertrans' component={ProtectedRoutes}></Route>
            <Route path='/autotransfer' component={ProtectedRoutes}></Route>
            
            {/* Profiles */}
            <Route path='/add-profile/:id' component={ProtectedRoutes}></Route>
            <Route path='/profile/:id' component={ProtectedRoutes}></Route>

            {/* Roles */}
            <Route path = '/roles' component={ProtectedRoutes}></Route>
            <Route path = '/add-role' component={ProtectedRoutes}></Route>

            {/* Permissions */}
            <Route path = '/permissions' component={ProtectedRoutes}></Route>

            {/* Monitoring report */}
            <Route path = '/institutions-performance' component={ProtectedRoutes}></Route>
            <Route path = '/terminals-performance/:id' component={ProtectedRoutes}></Route>
            

            {/* Global Settings */}
            <Route path='/settings' component={ProtectedRoutes}></Route>

          </Suspense>
        </Switch>
      </HashRouter>
    </React.Fragment>
  );
}

export default App;
